<template>
  <v-row
    class="pa-0 ma-0"
    style="gap: 5px"
    v-if="item.tags?.length"
  >
    <v-chip
      v-for="tag in item.tags"
      :key="tag.id"
      :color="tag.color || 'primary'"
      small
    >
      <v-icon
        v-if="tag.service"
        size="12px"
        class="mr-1"
        >mdi-wrench</v-icon
      >
      {{ tag.title }}</v-chip
    >
  </v-row>
</template>

<script>
  export default {
    name: 'OrderReviewTagsRow',
    props: {
      item: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped></style>
